/*
 * Copyright (c) 2020
 * Company: G-Portal
 * Filename: getters.ts
 * Class: getters.ts
 * Author: Karl Magerl<karl@g-portal.com>
 * Version:
 */

import { GetterTree } from 'vuex';
import { MutationRequestStatus, RootState } from '../types';
import { AuthState, Customer } from './types';

export const getters: GetterTree<AuthState, RootState> = {
  success: (state) => state.customer.status === MutationRequestStatus.SUCCESS,
  error: (state) => state.customer.status === MutationRequestStatus.ERROR,
  loading: (state) => state.customer.status === MutationRequestStatus.LOADING,
  customer: (state): Customer => state.customer.data,
  isLoggedIn: (state): boolean => state.customer.status === MutationRequestStatus.SUCCESS
    && state.customer.data != null,
  isAdmin: (state, getter): boolean => getter.isLoggedIn && state.customer.data.is_admin === true,
};
